import { cva } from '@/styled-system/css';

export const toggleCardFooterRecipe = cva({
  base: {
    marginBlockStart: 'ToggleCard.Footer.margin.to-Body',
  },
  variants: {
    divider: {
      true: {
        paddingBlockStart: 'ToggleCard.Footer.padding.from-Footer',
        borderBlockStartWidth: 'ToggleCard.Footer',
        borderBlockStartStyle: 'solid',
        borderBlockStartColor: 'ToggleCard.Footer.border',
      },
      false: {},
    },
  },
});
